export function isInstanceOf<T>(
  clazz: new (...args: any[]) => T,
): (value: unknown) => value is T {
  return (value): value is T => value instanceof clazz;
}
